import React, { useMemo, memo } from 'react'
import dynamic from 'next/dynamic'
import getCollectionProductData from '@helpers/filters/getCollectionProductData'
import styles from './styles.module.scss'
import { Collection } from 'types/collection'
import { FilterOption } from 'types/filters'

const CollectionProductList = dynamic(() => import('../CollectionProductList'))
const CollectionNoResult = dynamic(() => import('../CollectionNoResult'))

type CollectionWrapperProps = {
  collections: Collection[]
  filterOptions: FilterOption[]
  variantExist: boolean
  inventoryReady: boolean
}

const CollectionWrapper = ({
  collections,
  filterOptions,
  variantExist,
  inventoryReady
}: CollectionWrapperProps) => {
  const enforceVariantFiltering = inventoryReady && variantExist
  const { collectionsWithFilteredProducts } = useMemo(
    () =>
      getCollectionProductData({
        collections,
        filterOptions,
        variantExist: enforceVariantFiltering
      }),
    [collections, filterOptions, enforceVariantFiltering]
  )
  const numberOfCollections = collectionsWithFilteredProducts.length

  if (numberOfCollections === 0 && inventoryReady) {
    return (
      <section className={styles.collection}>
        <CollectionNoResult />
      </section>
    )
  }

  const collectionProducts = collectionsWithFilteredProducts.flatMap(
    ({ items }) => items
  )

  return <CollectionProductList products={collectionProducts} />
}

export default memo(CollectionWrapper)
